import { STARTUP_START, STARTUP_FINISH } from '../types/startup'

export const startupStart = () => ({ type: STARTUP_START })
export const startupFinish = () => ({ type: STARTUP_FINISH })
